const TOKEN_KEY = 'token';

let memoryToken = null;

export const setToken = (token) => {
  memoryToken = token;
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  if (!memoryToken) {
    memoryToken = localStorage.getItem(TOKEN_KEY);
  }
  return memoryToken;
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  memoryToken = null;
};



// WEBPACK FOOTER //
// ./src/utils/tokenStorage.js